"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CACHE_STORE_TYPE = void 0;
exports.CACHE_STORE_TYPE = {
    REDIS: 'REDIS',
    DB: 'DB'
};
//# sourceMappingURL=cacheStoreType.js.map